import React, { useState, useEffect } from 'react';
import { Card, Descriptions, Spin, message, Button, Tag } from 'antd';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { ArrowLeftOutlined } from '@ant-design/icons';
import CopyableText from '../../components/CopyableText';
import { formatDateTime } from '../../utils/format';
import request from '../../utils/request';

const AddressDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [address, setAddress] = useState(null);
  const [loading, setLoading] = useState(true);

  const loadAddressDetail = async () => {
    setLoading(true);
    try {
      const data = await request.get(`/api/explorer/addresses/${id}`);
      setAddress(data.address);
    } catch (error) {
      message.error('加载地址详情失败');
      console.error('Address detail error:', error);
    }
    setLoading(false);
  };

  useEffect(() => {
    loadAddressDetail();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  if (loading) {
    return (
      <div style={{ textAlign: 'center', padding: '100px 0' }}>
        <Spin size="large" />
      </div>
    );
  }

  if (!address) {
    return (
      <Card>
        <p>地址不存在</p>
        <Button onClick={() => navigate('/dashboard/explorer')}>返回浏览器</Button>
      </Card>
    );
  }

  return (
    <div>
      <div style={{ marginBottom: 16 }}>
        <Button icon={<ArrowLeftOutlined />} onClick={() => navigate(-1)}>
          返回
        </Button>
      </div>

      <Card title="地址详情">
        <Descriptions column={1} bordered>
          <Descriptions.Item label="地址">
            <CopyableText text={address.address} />
          </Descriptions.Item>
          <Descriptions.Item label="类型">{address.type || '-'}</Descriptions.Item>
          <Descriptions.Item label="状态">
            <Tag color={address.is_used ? 'blue' : 'default'}>
              {address.is_used ? '已使用' : '未使用'}
            </Tag>
          </Descriptions.Item>
          {address.wallet_name && (
            <Descriptions.Item label="钱包名">{address.wallet_name}</Descriptions.Item>
          )}
          <Descriptions.Item label="创建时间">
            {formatDateTime(address.inserted_at)}
          </Descriptions.Item>
        </Descriptions>
        {address.accounts && address.accounts.length > 0 && (
          <Descriptions column={1} bordered style={{ marginTop: -1 }}>
            <Descriptions.Item label="资产余额">
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '16px' }}>
                {address.accounts.map((acc) => (
                  <span key={acc.id}>
                    <Link to={`/dashboard/explorer/asset/${acc.asset_id}`}>{acc.asset_symbol}</Link>
                    {' '}
                    <span style={{ fontFamily: 'monospace' }}>
                      {acc.balance ? parseFloat(acc.balance).toFixed(8) : '0'}
                    </span>
                  </span>
                ))}
              </div>
            </Descriptions.Item>
          </Descriptions>
        )}
      </Card>
    </div>
  );
};

export default AddressDetail;
